module.exports = __webpack_public_path__ + "static/media/brand-refresh-cookies.2431a553.svg";